//Nodes Modules
import React, { useEffect, useContext, useState, useRef } from "react";
import { UserContext } from "../context/userContext.jsx";
import { DragAndDropContext } from "../context/DragAndDropContext.jsx";
import Axios from "../axios";
import { connect } from "react-redux";
import { track } from "@amplitude/analytics-browser";
import { ActionCreators as UndoActionCreators } from "redux-undo";
import Joyride, { EVENTS, STATUS } from "react-joyride";
import { ToastContainer } from "react-toastify";
import shortid from "shortid";

//JSX Commponents
import * as actionTypes from "../store/Actions/actions";
import SaveOrCancel from "../components/CreateNewTemplate/SaveOrCancel";
import Library from "../components/Modal/Library/Library";
import BlocksThumbDND from "../components/Tool/Layout/Blocks/BlocksThumbDND";
import SaveAsBlock from "../components/Controls/SaveAs/SaveAsBlock/SaveAsBlock";
import Templates from "../components/Tool/Layout/Templates/Templates.jsx";
import cloneDeep from "lodash.clonedeep";
import * as UTILS from "../utils/Utils.jsx";
import { tool } from "../utils/tool";
import ElementsRender from "./elementsRender";
import Blocks from "../components/Tool/Layout/Blocks/Blocks";
import GridGuidelines from "./GridGuidelines";
import { Toolbar as OLDToolbar } from "../components/Toolbar/Toolbar_old.jsx";
import { Toolbar } from "../components/Toolbar/Toolbar.jsx";
import Navbar from "../components/Header/Navbar.jsx";
import { SideBar } from "../components/VersionHistory/SideBar.jsx";
import { Title } from "../components/VersionHistory/Title.jsx";
import { ViewMode } from "../components/Header/ViewMode.jsx";
import Icons from "../components/Tool/Layout/Icons/Icons.jsx";

//Assets
import "../assets/images/button.png";
import "../assets/scss/Editor.scss";
import "react-toastify/dist/ReactToastify.css";
import "../assets/styles/basic.css";
import "../assets/styles/inputs.css";
import "../assets/styles/buttons.scss";
import "../assets/styles/utils.scss";
import "../assets/styles/item.scss";
import "../assets/styles/element-wrappers.scss";
import DragMark from "../assets/images/dragMark.png";
import { transformHtmlInLayout, transformHtmlInLayoutList } from "../utils/transformHTLMToTable.js";
import { notification } from "antd";

let id = 0;
//https://php8-dev-platform.flimp.cloud/editor/?u=835b1918a43577a8614a185d50f7a6b6&f=8771015a69ef765a1b52f923b0417244&sn=LQ2pSyg9PytnwL1OVOMHFhePqFNkV31VKrZsL7Lv
let userID = "835b1918a43577a8614a185d50f7a6b6";
let sessionID = "LQ2pSyg9PytnwL1OVOMHFhePqFNkV31VKrZsL7Lv";
let flimpID = "8771015a69ef765a1b52f923b0417244";
let initP = 0;
let removed = null;
let dragIcon = document.createElement("img");
dragIcon.src = DragMark;
dragIcon.style.marginTop = "-20px";

const Flimp = (props) => {
  const [state, setState] = useState({
    addBlockElementId: "",
    addBlockFlag: false,
    addedIndex: null,
    animateModal: false,
    blockHeight: null,
    canvasBg: "",
    choosenBlockElement: [],
    clickedID: "",
    clickedImage: null,
    clickedImageID: null,
    clickedSave: false,
    closingEditor: false,
    containerMinHeight: "92vh",
    convert: false,
    createNewCard: false,
    createNewLayoutTitle: false,
    creatingSnapshot: false,
    description: "",
    dragOverChildren: null,
    dragOverColumn: null,
    dragOverParent: null,
    droppedOnRowFromMenu: false,
    dscrError: false,
    editID: null,
    editText: "",
    editTextIndex: "",
    editTextModal: false,
    errorInSave: false,
    footer: [],
    generatedNew: false,
    generatingNew: false,
    getDataError: false,
    getDataLoader: false,
    globalStyle: false,
    globalStyleComponents: false,
    googleFonts: UTILS.googleFonts,
    gridGuideColumns: 12,
    gridGuideGutterSpace: 2,
    gridGuideLineColor: { r: 38, g: 169, b: 225, a: 0.25 },
    header: [],
    id: 0,
    imageClicked: null,
    isManagingFocus: false,
    itemID: null,
    layout: [],
    layoutTool: false,
    limitExceed: false,
    lineHeight: 25,
    listClickLoader: false,
    listClickLoaderID: "",
    loadedData: true,
    loader: true,
    loading: false,
    loadingCompleted: true,
    meta_title: null,
    modalUpload: false,
    moduleDragStarted: false,
    mobileView: false,
    navigationSetting: false,
    newCardDescription: "",
    newCardTitle: "",
    newChangeDetected: false,
    newLayoutTitle: "",
    payload: null,
    portalHeight: null,
    portalList: [],
    portalWidth: null,
    reload: false,
    removedColumn: null,
    removedIndex: null,
    run: false,
    saveCreateModal: false,
    saveExit: false,
    saveForNew: false,
    saved: false,
    selectedFile: null,
    selectedFileLoaded: null,
    snapshotApiError: null,
    stepIndex: 0,
    steps: UTILS.steps,
    text: "",
    title: "",
    titleError: false,
    toggleGuidelines: false,
    tool: UTILS.tool,
    validation: false,
    videoClicked: null,
    videoDataID: "",
    wentWrong: false,
    showAddElement: true,
  });
  const [shortCode, setShortCode] = useState("");
  const [joyrideState, setJoyrideState] = useState({
    run: false,
    steps: UTILS.steps,
    stepIndex: 0,
    tourActive: false,
  });

  let canvasHeightWidthRef = useRef(null);

  const { setUserData } = useContext(UserContext);
  const { onDragEnter, onDrop, dragOverParent, dragOverElement } =
    useContext(DragAndDropContext);

     const [notificationApi, notificationContext] =
        notification.useNotification();
  useEffect(() => {
    getFlimpData();
  }, []);

  const getFlimpData = () => {
    if (
      UTILS.getParameterByName("u") &&
      UTILS.getParameterByName("f") &&
      UTILS.getParameterByName("sn")
    ) {
      userID = UTILS.getParameterByName("u");
      flimpID = UTILS.getParameterByName("f");
      sessionID = UTILS.getParameterByName("sn");
      setUserData(userID, sessionID, flimpID);
      Axios.MicrositeService.GET_MICROSITE(userID, flimpID, sessionID).then(
        (response) => {
          let infoTitle = response.data.body[0].flimp_title;
          let infoDesc = response.data.body[0].flimp_desc;
          let infoMeta_title = response.data.body[0].flimp_meta_title;
          props.infoPushTitle(infoTitle);
          props.infoPushDesc(infoDesc);
          props.infoPushMetaTitle(infoMeta_title);

          if (
            response.data.statusCode == "success" &&
            response.data.body[0].flimp_data
          ) {
            setShortCode(response.data.body[0].short_code);
            let templateID = JSON.parse(
              response.data.body[0].flimp_data
            ).flimpTemplateID;
            props.pushFlimpTemplateID(templateID);
            let layout = JSON.parse(response.data.body[0].flimp_data);
            let navigationStyle = JSON.parse(
              response.data.body[0].flimp_data
            ).navigationStyle;
            let navigationSearch = JSON.parse(response.data.body[0].flimp_data)
              .navigationSearch
              ? JSON.parse(response.data.body[0].flimp_data).navigationSearch
              : null;
            JSON.parse(response.data.body[0].flimp_data).navigationSearch &&
              props.push_navigation_search(navigationSearch);

            let navigationAlign = JSON.parse(response.data.body[0].flimp_data)
              .navigationAlign
              ? JSON.parse(response.data.body[0].flimp_data).navigationAlign
              : "right";
            JSON.parse(response.data.body[0].flimp_data).navigationAlign &&
              props.push_navigation_align(navigationAlign);

            props.push_navigation_style(navigationStyle);
            layout.preset = [];
            layout.preset.length == 0 &&
              layout.colorsGlobal.map((item, index) => {
                layout.preset.push(item.hex);
              });
            layout.layout == null ? (layout.layout = []) : layout.layout;
            updateFormId(layout.layout);
            layout.layoutList == null
              ? (layout.layoutList = [["home", []]])
              : layout.layoutList;
            layout.layoutLanguages =
              layout.layoutLanguages || layout.layoutList.map(() => "en");
            layout.layoutTitle = layout.layoutTitle || "home";
            layout.anchorNavigation = layout.anchorNavigation || {
              enable: false,
              sticky: false,
              page: layout.layoutTitle,
              tabs: [],
            };

            formIdAllData(layout.layoutList);
            let containerWidth = layout.containerWidth;
            props.pushContainerWidth(containerWidth);
            props.pushBgRepeat(layout.bgRepeat || "no-repeat");
            props.pushBgSize(layout.bgSize || "auto");
            props.pushBgContainerRepeat(
              layout.bgContainerRepeat || "no-repeat"
            );
            props.pushBgContainerSize(layout.bgContainerSize || "auto");
            props.pushBGimage(
              response.data.body[0].bgImage,
              response.data.body[0].bgImageId
            );
            props.pushBGContainerimage(
              response.data.body[0].bgImageContainer,
              response.data.body[0].bgImageContainerId
            );

            setState({
              ...state,
              generatedNew: true,
              loadingCompleted: false,
            });
            setState({ ...state, meta_title: infoMeta_title }, () => {
              document.title =
                state.meta_title == null ? "Flimp Media" : props.meta_title;
            });

            let transfomedLayout = transformHtmlInLayout(layout.layout);
            let transfomedLayoutList = transformHtmlInLayoutList(layout.layoutList);


            props.canvasPush(layout);
            props.layoutArray(layout.layoutTitle, transfomedLayout);
            props.layoutListArray(transfomedLayoutList);
            props.clearHistory();
          } else if (
            response.data.statusCode == "success" &&
            !response.data.body[0].flimp_data
          ) {
            setShortCode(response?.data?.body[0]?.short_code);
            props.canvasPush(UTILS.NewCanvas);
            props.clearHistory();
          }
        }
      );
    } else {
      setUserData(userID, sessionID, flimpID);
      Axios.MicrositeService.GET_MICROSITE(userID, flimpID, sessionID).then(
        (response) => {
          let infoTitle = response.data.body[0].flimp_title;
          let infoDesc = response.data.body[0].flimp_desc;
          let infoMeta_title = response.data.body[0].flimp_meta_title;
          let navigationStyle = null;
          const rawFlimpData = response.data.body[0].flimp_data;
          // Safe parse the JSON string to get the navigationStyle
          if (rawFlimpData && typeof rawFlimpData === "string" && rawFlimpData.trim()) {
            try {
              const parsed = JSON.parse(rawFlimpData);
              navigationStyle = parsed && parsed.navigationStyle;
            } catch (_) {
              // invalid JSON
            }
          }

          props.push_navigation_style(navigationStyle);
          props.infoPushTitle(infoTitle);
          props.infoPushDesc(infoDesc);
          props.infoPushMetaTitle(infoMeta_title);

          if (
            response.data.statusCode == "success" &&
            response.data.body[0].flimp_data
          ) {
            setShortCode(response.data.body[0].short_code);
            let navigationStyle = JSON.parse(
              response.data.body[0].flimp_data
            ).navigationStyle;
            props.push_navigation_style(navigationStyle);

            let navigationAlign = JSON.parse(response.data.body[0].flimp_data)
              .navigationAlign
              ? JSON.parse(response.data.body[0].flimp_data).navigationAlign
              : "right";

            JSON.parse(response.data.body[0].flimp_data).navigationAlign &&
              props.push_navigation_align(navigationAlign);
            let templateID = JSON.parse(
              response.data.body[0].flimp_data
            ).flimpTemplateID;
            props.pushFlimpTemplateID(templateID);
            let layout = JSON.parse(response.data.body[0].flimp_data);
            layout.layout == null ? (layout.layout = []) : layout.layout;
            updateFormId(layout.layout);
            layout.layoutList == null
              ? (layout.layoutList = [["home", []]])
              : layout.layoutList;
            layout.layoutLanguages =
              layout.layoutLanguages || layout.layoutList.map(() => "en");
            layout.layoutTitle = layout.layoutTitle || "home";
            layout.anchorNavigation = layout.anchorNavigation || {
              enable: false,
              sticky: false,
              page: layout.layoutTitle,
              tabs: [],
            };
            formIdAllData(layout.layoutList);
            layout.preset = [];
            layout.preset.length == 0 &&
              layout.colorsGlobal.map((item, index) => {
                layout.preset.push(item.hex);
              });
            let containerWidth = layout.containerWidth;
            props.pushContainerWidth(containerWidth);
            props.pushBgRepeat(layout.bgRepeat || "no-repeat");
            props.pushBgSize(layout.bgSize || "auto");
            props.pushBgContainerRepeat(
              layout.bgContainerRepeat || "no-repeat"
            );
            props.pushBgContainerSize(layout.bgContainerSize || "auto");
            props.pushBGimage(
              response.data.body[0].bgImage || "",
              response.data.body[0].bgImageId || ""
            );
            props.pushBGContainerimage(
              response.data.body[0].bgImageContainer || "",
              response.data.body[0].bgImageContainerId || ""
            );
            let transfomedLayout = transformHtmlInLayout(layout.layout);
            let transfomedLayoutList = transformHtmlInLayoutList(layout.layoutList);
            // let transfomedLayout = layout.layout;
            // let transfomedLayoutList = layout.layoutList;


            props.canvasPush(layout);
            props.layoutArray(layout.layoutTitle, transfomedLayout);
            props.layoutListArray(transfomedLayoutList);
            setState({ ...state, meta_title: infoMeta_title });
            document.title =
              state.meta_title == null ? "Flimp Media" : props.meta_title;
            setState({ ...state, generatedNew: true });
            props.clearHistory();
          } else if (
            response.data.statusCode == "success" &&
            !response.data.body[0].flimp_data
          ) {
            setShortCode(response?.data?.body[0]?.short_code);
            props.canvasPush(UTILS.NewCanvas);
            props.clearHistory();
          }
        }
      );
      setState({
        addedElement: false,
        loading: true,
      });
    }
  };

  const createSnapshot = () => {
    const portalHeight = canvasHeightWidthRef.current.clientHeight;

    let portalWidth = props.percentage
      ? 1200
      : canvasHeightWidthRef.current.clientWidth;
    setState({ ...state, portalHeight, portalWidth }, () => {
      let data = {
        u: userID,
        sn: sessionID,
        f: flimpID,
        w: state.portalWidth,
        h: state.portalHeight,
      };
      Axios.AWSService.CREATE_SNAPSHOT(data)
        .then((response) => {
          setState({
            ...state,
            saved: true,
            creatingSnapshot: false,
          });
          () => {
            setTimeout(
              function () {
                setState({ ...state, saved: false, clickedSave: false });
              }.bind(this),
              3000
            );
          };
        })
        .catch((error) => {
          setState({
            ...state,
            snapshotApiError: true,

            errorInSave: false,
            saved: false,
          });
        });
    });
  };

  const mobileView = () => {
    setState({
      ...state,
      mobileView: !state.mobileView,
    });
  };

  const getSizes = (sizes, id) => {
    const { layout } = state;
    const newList = cloneDeep(layout);
    newList.map((item, index) => {
      if (item && item.id == id) {
        item.deskWidth = sizes;
        return item;
      }
      if (item && item.id !== id && item.columns) {
        Object.keys(item.columns).map((col, colIndex) => {
          item.columns[col].map((colItem, colItemIndex) => {
            if (colItem.id == id) {
              colItem.deskWidth = sizes;
              return colItem;
            }
          });
        });
      }
    });
    props.layoutArray(props.layoutTitle, newList);
  };

  const addRemoveColumn = (event, ID, whatToDo, dataModule) => {
    event.preventDefault();
    event.stopPropagation();
    const cloneList = cloneDeep(props.layout);
    let itemToAdd = null;
    cloneList.map((item, index) => {
      if (item && item.id == ID) {
        itemToAdd = item;
      }
      if (item && item.columns && item.id !== ID) {
        Object.keys(item.columns).map((colm, colIndex) => {
          item.columns[colm].map((colmItem, colmIndex) => {
            if (colmItem.id == ID) {
              itemToAdd = colmItem;
            }
          });
        });
      }
    });
    if (
      itemToAdd !== null &&
      whatToDo == "add" &&
      Object.keys(itemToAdd.columns).length <= 5 &&
      Object.keys(itemToAdd.columns).length >= 1
    ) {
      let indexToAdd = Object.keys(itemToAdd.columns).length + 1;
      let columnKey = indexToAdd && "c" + indexToAdd;
      let indexToCopy = Object.keys(itemToAdd.columns).length;
      let columnKeyCopy = indexToCopy && "c" + indexToCopy;

      const dataToUse = cloneDeep(itemToAdd.columns[columnKeyCopy]);
      let copiedData =
        dataModule &&
        UTILS.IDFilter(
          dataToUse,
          (item) => {
            item.id = "F" + shortid();
          },
          (colItem) => {
            colItem.id = "F" + shortid();
          },
          (colItemNested) => {
            colItemNested.id = "F" + shortid();
          }
        );

      itemToAdd.columns[columnKey] = dataModule ? copiedData : [];
      itemToAdd.deskWidth.splice(indexToAdd, 0, 50);
      Object.keys(itemToAdd.columns).length > 1 && itemToAdd.deskWidth[0] == 100
        ? (itemToAdd.deskWidth[0] = 50)
        : null;

      dataModule
        ? (itemToAdd.columnsBG[columnKey] = itemToAdd.columnsBG[columnKeyCopy])
        : (itemToAdd.columnsBG[columnKey] = {
          bgImage: "",
          bgColor: "transparent",
          bgRepeat: "no-repeat",
          borderWidth: "0",
          borderColor: "#ffffff",
          bgSize: "auto",
          gutterSpaceUnit: "px",
          gutterSpaceLeft: "0",
          gutterSpaceRight: "0",
          gutterSpaceMobileLeft: "0",
          gutterSpaceMobileRight: "0",
          gutterSpaceTopBottom_T: "0",
          gutterSpaceTopBottom_B: "0",
          gutterSpaceTopBottomMobileTop: "0",
          gutterSpaceTopBottomMobileBottom: "0",
        });

      cloneList.map((item, index) => {
        if (item && item.id == ID) {
          return itemToAdd;
        }
        if (item && item.id !== ID && item.columns) {
          Object.keys(item.columns).map((nest, nestIndex) => {
            return item.columns[nest].map((nestItem, nestItemIndex) => {
              if (nestItem.id == ID) {
                return itemToAdd;
              }
            });
          });
        }
      });
      props.layoutArray(props.layoutTitle, cloneList);
    }
    if (
      itemToAdd !== null &&
      whatToDo == "remove" &&
      Object.keys(itemToAdd.columns).length <= 6 &&
      Object.keys(itemToAdd.columns).length > 1
    ) {
      let indexToAdd = Object.keys(itemToAdd.columns).length;
      let columnKey = indexToAdd && "c" + indexToAdd;
      delete itemToAdd.columns[columnKey];
      itemToAdd.deskWidth.pop();
      delete itemToAdd.columnsBG[columnKey];
      Object.keys(itemToAdd.columns).length == 1
        ? (itemToAdd.deskWidth[0] = 100)
        : null;

      cloneList.map((item, index) => {
        if (item && item.id == ID) {
          return itemToAdd;
        }
        if (item && item.id !== ID && item.columns) {
          Object.keys(item.columns).map((nest, nestIndex) => {
            return item.columns[nest].map((nestItem, nestItemIndex) => {
              if (nestItem.id == ID) {
                return itemToAdd;
              }
            });
          });
        }
      });
      props.layoutArray(props.layoutTitle, cloneList);
    }
  };

  const deleteElement = (id) => {
    var amplitudeDeletedElement;
    setState({
      ...state,
      newChangeDetected: true,
    });
    let layout = cloneDeep(props.layout);
    layout.map((item) => {
      item.id === id ? (amplitudeDeletedElement = item.data) : "";
    });
    const newLayout = layout
      .filter((item) => {
        return item.id !== id;
      })
      .map((item) => {
        if (item.data == "Row" || item.data == "Accordion") {
          Object.keys(item.columns).map((col, colIndex) => {
            return item.columns[col].map((rowDel, index) => {
              if (rowDel.id == id) {
                amplitudeDeletedElement = rowDel.data;
                item.columns[col].splice(index, 1);
              }
              if (rowDel.data == "Row" || rowDel.data == "Accordion") {
                Object.keys(rowDel.columns).map((nestObj, nestIndex) => {
                  return rowDel.columns[nestObj].map(
                    (nestItem, nestItemIndex) => {
                      if (nestItem.id == id) {
                        amplitudeDeletedElement = nestItem.data;
                        rowDel.columns[nestObj].splice(nestItemIndex, 1);
                      }
                    }
                  );
                });
              }
            });
          });
        }
        return item;
      });
    track("Element Deleted", {
      elementType: amplitudeDeletedElement,
      elementId: id,
    });
    props.layoutArray(props.layoutTitle, newLayout);
  };

  const cloneElement = (elementID) => {
    setState({
      ...state,
      newChangeDetected: true,
    });
    let layout = cloneDeep(props.layout);

    const cloneItem = (item) => {
      let newItem = cloneDeep(item);
      newItem.id = "F" + shortid();
      if (newItem.data === "FORM") {
        newItem.identifier = `Data-${newItem.id.slice(0, 4)}`;
      }
      if (newItem.columns) {
        Object.keys(newItem.columns).forEach((col) => {
          newItem.columns[col] = newItem.columns[col].map((subItem) =>
            cloneItem(subItem)
          );
        });
      }
      return newItem;
    };

    const processLayout = (layout) => {
      return layout
        .map((item) => {
          if (item.id === elementID) {
            let clonedItem = cloneItem(item);
            return [item, clonedItem];
          } else if (item.columns) {
            Object.keys(item.columns).forEach((col) => {
              item.columns[col] = processLayout(item.columns[col]);
            });
          }
          return item;
        })
        .flat();
    };

    let newLayout = processLayout(layout);
    props.layoutArray(props.layoutTitle, newLayout);
  };

  const changeColmLayout = (event, ID, layoutWidth) => {
    event.preventDefault();
    let whatToDo = "";
    let columnLengthDiff = 0;
    const cloneList = cloneDeep(props.layout);
    let itemToAdd = null;
    cloneList.map((item, index) => {
      if (item && item.id == ID) {
        itemToAdd = item;
      }
      if (item && item.columns && item.id !== ID) {
        Object.keys(item.columns).map((colm, colIndex) => {
          item.columns[colm].map((colmItem, colmIndex) => {
            if (colmItem.id == ID) {
              itemToAdd = colmItem;
            }
          });
        });
      }
    });

    if (Object.keys(itemToAdd.columns).length === layoutWidth.length) {
      itemToAdd.deskWidth = [...layoutWidth];

      cloneList.map((item, index) => {
        if (item && item.id == ID) {
          return itemToAdd;
        }
        if (item && item.id !== ID && item.columns) {
          Object.keys(item.columns).map((nest, nestIndex) => {
            return item.columns[nest].map((nestItem, nestItemIndex) => {
              if (nestItem.id == ID) {
                return itemToAdd;
              }
            });
          });
        }
      });

      props.layoutArray(props.layoutTitle, cloneList);
    } else if (Object.keys(itemToAdd.columns).length < layoutWidth.length) {
      whatToDo = "add";
      columnLengthDiff =
        layoutWidth.length - Object.keys(itemToAdd.columns).length;
    } else if (Object.keys(itemToAdd.columns).length > layoutWidth.length) {
      whatToDo = "remove";
      columnLengthDiff =
        Object.keys(itemToAdd.columns).length - layoutWidth.length;
    }

    if (
      itemToAdd !== null &&
      whatToDo == "add" &&
      columnLengthDiff > 0 &&
      Object.keys(itemToAdd.columns).length <= 6 &&
      Object.keys(itemToAdd.columns).length >= 1
    ) {
      itemToAdd.deskWidth = [...layoutWidth];
      for (let i = 0; i < columnLengthDiff; i++) {
        let indexToAdd = Object.keys(itemToAdd.columns).length + 1;
        let columnKey = indexToAdd && "c" + indexToAdd;
        itemToAdd.columns[columnKey] = [];
        itemToAdd.columnsBG[columnKey] = {
          bgImage: "",
          bgColor: "transparent",
          bgRepeat: "no-repeat",
          borderWidth: "0",
          borderColor: "#ffffff",
          bgSize: "auto",
          gutterSpaceUnit: "px",
          gutterSpaceLeft: "0",
          gutterSpaceRight: "0",
          gutterSpaceMobileLeft: "0",
          gutterSpaceMobileRight: "0",
          gutterSpaceTopBottom_T: "0",
          gutterSpaceTopBottom_B: "0",
          gutterSpaceTopBottomMobileTop: "0",
          gutterSpaceTopBottomMobileBottom: "0",
        };
      }

      cloneList.map((item, index) => {
        if (item && item.id == ID) {
          return itemToAdd;
        }
        if (item && item.id !== ID && item.columns) {
          Object.keys(item.columns).map((nest, nestIndex) => {
            return item.columns[nest].map((nestItem, nestItemIndex) => {
              if (nestItem.id == ID) {
                return itemToAdd;
              }
            });
          });
        }
      });
      props.layoutArray(props.layoutTitle, cloneList);
    }
    if (
      itemToAdd !== null &&
      whatToDo == "remove" &&
      columnLengthDiff > 0 &&
      Object.keys(itemToAdd.columns).length <= 6 &&
      Object.keys(itemToAdd.columns).length > 1
    ) {
      itemToAdd.deskWidth = [...layoutWidth];
      for (let i = 0; i < columnLengthDiff; i++) {
        let indexToRemove = Object.keys(itemToAdd.columns).length;
        let columnKey = indexToRemove && "c" + indexToRemove;
        delete itemToAdd.columns[columnKey];
        delete itemToAdd.columnsBG[columnKey];
      }
      cloneList.map((item, index) => {
        if (item && item.id == ID) {
          return itemToAdd;
        }
        if (item && item.id !== ID && item.columns) {
          Object.keys(item.columns).map((nest, nestIndex) => {
            return item.columns[nest].map((nestItem, nestItemIndex) => {
              if (nestItem.id == ID) {
                return itemToAdd;
              }
            });
          });
        }
      });
      props.layoutArray(props.layoutTitle, cloneList);
    }
  };

  const postData = () => {
    "saveMicrositeFunction()", props.storeDATA;
    let payload = JSON.stringify(props.storeDATA);

    let data = {
      fd: payload,
      f: flimpID,
      u: userID,
      sn: sessionID,
    };
    setState({
      ...state,
      clickedSave: true,
      errorInSave: false,
    });
    Axios.MicrositeService.POST_MICROSITE(data)
      .then((response) => {
        if (response.data.statusCode === "success") {
          setState(
            {
              ...state,
              addedElement: false,
              creatingSnapshot: true,
            },
            () => {
              createSnapshot();
            }
          );
        }
        if (response.data.statusCode !== "success") {
          setState({
            ...state,
            errorInSave: true,
            saved: false,
            clickedSave: false,
          });
        }
        if (response.data.statusCode == "401") {
          window.location =
            location.protocol + "//" + location.hostname + "/login";
        }
      })
      .catch((error) => {
        setState({
          ...state,
          errorInSave: true,
          saved: false,
          clickedSave: false,
        });
      });
  };

  const saveAndExit = () => {
    setState({
      saveAndExit: true,
    });

    const payLoad = JSON.stringify(props.storeDATA);
    const data = { fd: payLoad, f: flimpID, u: userID, sn: sessionID };
    Axios.MicrositeService.POST_MICROSITE(data).then((response) => {
      if (response.data.statusCode === "success") {
        setState({
          saved: true,
          saveAndExit: false,
        });

        let portalHeight = canvasHeightWidthRef.current.clientHeight;
        let portalWidth = props.percentage ? 1200 : canvasHeightWidthRef.current.clientWidth;
        let snapData = {
          u: userID,
          sn: sessionID,
          f: flimpID,
          w: portalWidth,
          h: portalHeight,
        };
        result = Axios.AWSService.CREATE_SNAPSHOT(snapData)
        .then((response) => {
          setState({
            ...state,
            saved: true,
            creatingSnapshot: false,
          });
          () => {
            setTimeout(
              function () {
                setState({ ...state, saved: false, clickedSave: false });
              }.bind(this),
              3000
            );
          };
           notificationApi["info"]({
              message: "Save & Exit",
              description: (
                  <>
                      <div
                          style={{
                              color: "green",
                          }}
                      >
                          Data is stored successfully,
                      </div>
                      <div
                          style={{ color: "green" }}
                      >    Snapshot generated successfully,
                      </div>
                  </>
              ),
              placement: "topRight",
              style: {
                width: 300,
              },
          });

          setTimeout(
            function () {
              setState({
                saved: false,
              });

              const host = window.location.protocol + "//" + window.location.host + '/canvas/my-canvas';
              window.location = host;
            }.bind(this),
            2000
          );

        })
        .catch((error) => {
          setState({
            ...state,
            snapshotApiError: true,

            errorInSave: false,
            saved: false,
          });
          notificationApi["info"]({
              message: "Save & Exit",
              description: (
                  <>
                      <div
                          style={{
                              color: "green",
                          }}
                      >
                          Data is stored
                          successfully,
                      </div>
                      <div
                          style={{ color: "red" }}
                      >
                          Failed to generate
                          snapshot
                      </div>
                  </>
              ),
              placement: "topRight",
              style: {
                width: 300,
              },
          });
        });
      }
    });
  };

  const cancelExit = () => {
    const host = window.location.protocol + "//" + window.location.host + '/canvas/my-canvas';
    window.location = host;
  };

  const setTitleValueInRedux = () => {
    const pageExist = getKeyArray().filter((title, index) => {
      return title == state.newLayoutTitle;
    });
    if (
      (state.newLayoutTitle.length > 0) &
      (state.newLayoutTitle.length < 40) &
      (pageExist.length == 0) &
      (props.layoutList.length < 30)
    ) {
      props.setLayoutTitle(state.newLayoutTitle);
      const newLayoutLanguages = props.layoutLanguages.slice();
      newLayoutLanguages.push(props.defaultLocale);
      props.setLayoutLanguages(newLayoutLanguages);
      props.setDefaultPage(state.newLayoutTitle);
    }
    setState({
      newLayoutTitle: "",
    });
  };

  const toggleUploadPopup = () => {
    setState({
      ...state,
      videoClicked: null,
      modalUpload: false,
      selectedFile: null,
      clickedImage: false,
      clickedImageID: null,
    });
  };


  const getKeyArray = () => {
    const keyArray = props.layoutList.map((value) => {
      return value[0];
    });

    return keyArray;
  };

  const translateStringLinkToObjectLink = () => {
    const objectArray = props.layoutList.map((value) => {
      return {
        title: value[0],
        value: "#" + UTILS.urlHashSegmentFormat(value[0]),
      };
    });
    return objectArray;
  };
  const startTour = () => {
    setJoyrideState((prev) => ({
      ...prev,
      run: true,
      tourActive: true,
      stepIndex: 0,
    }));
  };

  const handleJoyrideCallback = (data) => {
    const { status, type, index } = data;

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setJoyrideState((prev) => ({
        ...prev,
        run: false,
        tourActive: false,
      }));
    }

    if (type === EVENTS.STEP_AFTER) {
      setJoyrideState((prev) => ({
        ...prev,
        stepIndex: index + 1,
      }));
    }

    // Handle specific step actions
    switch (index) {
      case 1:
        if (type === "tooltip") {
          // Custom action for step 1
        }
        break;
      case 2:
        if (type === "step:after") {
          // Custom action for step 2
        }
        break;
    }
  };

  const animateModalState = (status) => {
    setState({
      animateModal: status,
    });
  };

  const addBlock = (id) => {
    setState({
      addBlockFlag: true,
      addBlockElementId: id,
    });
  };

  const onAddElementorColumn = (event, type, itemData, id) => {

    const layout = cloneDeep(props.layout);
    if (!id) {
      //assign last element id
      let lastElement = layout && layout[layout.length - 1];
      id = lastElement && lastElement.id;
    }
    if (type === "block") {
      addBlock(id);
      return false;
    }

    if (itemData.data) {
      event.preventDefault();
      event.stopPropagation();

      if (layout && layout.length > 0) {
        layout &&
          layout.map((item, index) => {
            if (item && item.id === id) {
              track("Element Added To Canvas", {
                elementType: item.data,
              });
              let newItem = cloneDeep(itemData);
              newItem.id = "F" + shortid();
              if (newItem.data === "FORM") {
                let customID = "F" + shortid();
                newItem.identifier = `Data-${customID.slice(0, 4)}`;
              }
              layout.splice(index + 1, 0, newItem);
              return item;
            }
            if (item && (item.data === "Row" || item.data === "Accordion")) {
              Object.keys(item.columns).map((col, colIndex) => {
                return item.columns[col].map((colItem, colItemIndex) => {
                  if (colItem.id == id) {
                    let newColItem = cloneDeep(itemData);
                    newColItem.id = "F" + shortid();

                    if (newColItem.data === "FORM") {
                      let customID = "F" + shortid();
                      newColItem.identifier = `Data-${customID.slice(0, 4)}`;
                    }
                    layout[index].columns[col].splice(
                      colItemIndex + 1,
                      0,
                      newColItem
                    );
                    return colItem;
                  }
                  if (
                    (colItem.data === "Row" || colItem.data === "Accordion") &&
                    colItem.id !== id
                  ) {
                    Object.keys(colItem.columns).map(
                      (colNested, colNestedIndex) => {
                        return colItem.columns[colNested].map(
                          (colItemNested, colItemNestedIndex) => {
                            if (colItemNested.id == id) {
                              let newColItem = cloneDeep(itemData);
                              newColItem.id = "F" + shortid();
                              if (newColItem.data === "FORM") {
                                let customID = "F" + shortid();
                                newColItem.identifier = `Data-${customID.slice(
                                  0,
                                  4
                                )}`;
                              }
                              layout[index].columns[col][colItemIndex].columns[
                                colNested
                              ].splice(colItemNestedIndex + 1, 0, newColItem);
                              return colItemNested;
                            }
                          }
                        );
                      }
                    );
                  }
                });
              });
            }
          });
      } else {
        let newItem = cloneDeep(itemData);
        newItem.id = "F" + shortid();
        if (newItem.data === "FORM") {
          let customID = "F" + shortid();
          newItem.identifier = `Data-${customID.slice(0, 4)}`;
        }
        layout.push(newItem);
      }

      props.layoutArray(props.layoutTitle, layout);
    }
  };

  const onAddElementorColumnInColumn = (event, type, itemData, id, colNum) => {

    const layout = cloneDeep(props.layout);
    if (type === "block") {
      //assign last element id
      let lastElement = layout && layout[layout.length - 1];
      id = lastElement && lastElement.id;
      addBlock(id);
      return false;
    }
    if (itemData.data) {
      event.preventDefault();
      event.stopPropagation();

      if (id) {
        layout &&
          layout.map((item, index) => {
            if (item && item.id === id) {
              track("Element Added To Canvas", {
                elementType: item.data,
              });
              let newItem = cloneDeep(itemData);
              newItem.id = "F" + shortid();

              if (newItem.data === "FORM") {
                let customID = "F" + shortid();
                newItem.identifier = `Data-${customID.slice(0, 4)}`;
              }
              if (item.columns && item.columns[colNum]) {
                layout[index].columns[colNum].push(newItem);
              }
              return false;
            }
            if (item && (item.data === "Row" || item.data === "Accordion")) {
              Object.keys(item.columns).map((col, colIndex) => {
                return item.columns[col].map((colItem, colItemIndex) => {
                  if (colItem.id == id) {
                    let newColItem = cloneDeep(itemData);
                    newColItem.id = "F" + shortid();
                    if (newColItem.data === "FORM") {
                      let customID = "F" + shortid();
                      newColItem.identifier = `Data-${customID.slice(0, 4)}`;
                    }
                    if (colItem.columns && colItem.columns[colNum]) {
                      layout[index].columns[col][colItemIndex].columns[
                        colNum
                      ].push(newColItem);
                    }
                    return false;
                  }
                });
              });
            }
          });
      } else {
        let newItem = cloneDeep(itemData);
        newItem.id = "F" + shortid();
        if (newItem.data === "FORM") {
          let customID = "F" + shortid();
          newItem.identifier = `Data-${customID.slice(0, 4)}`;
        }

        layout.push(newItem);
      }

      props.layoutArray(props.layoutTitle, layout);
    }
  };

  const updateFormId = (layout) => {
    layout.map((item) => {
      // (item)
      if (item) {
        if (item.data === "FORM") {
          let customID = "F" + shortid();
          if (item.identifier === undefined || item.identifier === null) {
            item.identifier = `Data-${customID.slice(0, 4)}`;
          }
          if (item.identifier === "") {
            item.identifier = `Data-${customID.slice(0, 4)}`;
          }
        }

        if (item.data === "Row") {
          Object.keys(item.columns).map((col) => {
            return item.columns[col].map((colItem) => {
              if (colItem.data === "FORM") {
                let customID = "F" + shortid();
                colItem.identifier =
                  colItem.identifier === undefined ||
                    colItem.identifier === null
                    ? `Data-${customID.slice(0, 4)}`
                    : colItem.identifier !== ""
                      ? colItem.identifier
                      : `Data-${customID.slice(0, 4)}`;
              }

              if (colItem.data === "Row") {
                Object.keys(colItem.columns).map((colnested) => {
                  return colItem.columns[colnested].map((colnestedItem) => {
                    let customID = "F" + shortid();
                    if (colnestedItem.data === "FORM") {
                      colnestedItem.identifier =
                        colnestedItem.identifier === undefined ||
                          colnestedItem.identifier === null
                          ? `Data-${customID.slice(0, 4)}`
                          : colnestedItem.identifier !== ""
                            ? colnestedItem.identifier
                            : `Data-${customID.slice(0, 4)}`;
                    }
                  });
                });
              }
            });
          });
        }
      }
    });
  };

  const formIdAllData = (layoutList) => {
    layoutList.map((layout) => {
      updateFormId(layout[1]);
    });
  };

  const setForegroundColor = () => {
    let containerBg = props.surroundBg;
    let rgb = [255, 255, 255, 100];
    if (props.surroundBg && typeof props.surroundBg === "string") {
      containerBg = UTILS.hexToRgbA(props.surroundBg);
      containerBg = containerBg.replace("rgba(", "");
      containerBg = containerBg.replace(")", "");
      containerBg = containerBg.split(",");
      rgb = containerBg;
    } else {
      rgb = props.surroundBg
        ? [
          props.surroundBg.r,
          props.surroundBg.g,
          props.surroundBg.b,
          props.surroundBg.a,
        ]
        : [255, 255, 255, 100];
    }
    let sum = Math.round(
      (parseInt(rgb[0]) * 299 +
        parseInt(rgb[1]) * 587 +
        parseInt(rgb[2]) * 114) /
      1000
    );
    return sum > 128 ? "#26a9e1" : "white";
  };

  return (
    <div className={"master-wrap "}>
      <Joyride
        callback={handleJoyrideCallback}
        continuous
        run={joyrideState.run}
        scrollToFirstStep
        showProgress
        showSkipButton
        steps={joyrideState.steps}
        stepIndex={joyrideState.stepIndex}
        styles={{
          options: {
            zIndex: 10000,
            primaryColor: "#000",
          },
        }}
      />


      <Toolbar
        mobileView={state.mobileView}
        state={state}
        short_code={shortCode}
        startTour={startTour}
        handleState={(state) => {
          setState((prevState) => ({
            ...prevState,
            ...state,
          }));
        }}
        initP={initP}
        saveAndExit={saveAndExit}
        postData={postData}
        cancelExit={cancelExit}
        canvasHeightWidth={canvasHeightWidthRef}
      />


      {props.tool === "Library" && (
        <Library
          modalUpload={state.modalUpload}
          toggleUploadPopup={() => {
            props.setTool(null);
          }}
          userID={userID}
          sessionID={sessionID}
          videoDataID={state.videoDataID}
          initP={initP}
          clickedImageID={null}
          videoClicked={null}
          fileType={null}
        />
      )}

      <div
        className={`main-content ${props.showHistory ? "history-content" : ""}`}
      >
        {props.showHistory && <Title />}

        <GridGuidelines
          gridGuideColumns={state.gridGuideColumns}
          gridGuideGutterSpace={state.gridGuideGutterSpace}
          gridGuideLineColor={state.gridGuideLineColor}
          toggleGuidelines={state.toggleGuidelines}
          mobileView={state.mobileView}
        >
          {!props.showHistory && (
            <ViewMode
              mobileView={state.mobileView}
              onClick={mobileView}
              setForegroundColor={setForegroundColor}
              saveAsBlock={state.animateModal}
            />
          )}
          <div
            className={
              state.mobileView
                ? "mobileView editor-container"
                : "editor-container"
            }
            style={
              state.mobileView
                ? {
                  backgroundColor: props.surroundBg
                    ? `rgba(${props.surroundBg.r},${props.surroundBg.g},${props.surroundBg.b},${props.surroundBg.a})`
                    : "",
                  backgroundImage: props.bgImageContainer
                    ? `url(${props.bgImageContainer})`
                    : "",
                  width: "375px",
                  WebkitJustifyContent: "center",

                  backgroundSize: props.bgContainerSize
                    ? props.bgContainerSize
                    : "auto",
                  backgroundPosition: "center",
                }
                : {
                  backgroundColor: props.surroundBg
                    ? `rgba(${props.surroundBg.r},${props.surroundBg.g},${props.surroundBg.b},${props.surroundBg.a})`
                    : "",
                  backgroundImage: props.bgImageContainer
                    ? `url(${props.bgImageContainer})`
                    : "",
                  backgroundRepeat: props.bgContainerRepeat
                    ? props.bgContainerRepeat
                    : "no-repeat",
                  backgroundSize: props.bgContainerSize
                    ? props.bgContainerSize
                    : "auto",
                  WebkitJustifyContent: "center",
                  justifyContent: "center",
                }
            }
          >
                {notificationContext}

            <div
              className={
                "editor-canvas " +
                (Object.keys(props.layoutList).length > 1 ? "show" : "hidden") +
                (state.mobileView ? " mobileView" : " ") +
                (props.layoutList.length > 1
                  ? " multiplePages "
                  : " nomultiplePages ") +
                (props.overrideCanvasFont ? " overrideLocalFont " : " ") +
                (dragOverParent &&
                  (dragOverParent.id === "canvas-drop-container") &
                  (dragOverElement === null)
                  ? " draggedOver"
                  : "")
              }
              ref={canvasHeightWidthRef}
              style={{
                width:
                  props.enableWidthForRow === true ||
                    props.containerWidth === "100%"
                    ? "100%"
                    : props.containerWidth,
                backgroundColor:
                  typeof props.containerBg == "string"
                    ? props.containerBg
                    : `rgba(
                      ${props.containerBg.r},
                      ${props.containerBg.g},
                      ${props.containerBg.b},
                      ${props.containerBg.a}
                    )`,
                paddingTop:
                  props.canvasPadding && !state.mobileView
                    ? props.canvasPadding
                      ? props.canvasPadding[0] +
                      (props.canvasPaddingUnit
                        ? props.canvasPaddingUnit
                        : "px")
                      : "0"
                    : props.canvasPaddingMobile && state.mobileView
                      ? props.canvasPaddingMobile
                        ? props.canvasPaddingMobile[0] +
                        (props.canvasPaddingUnit
                          ? props.canvasPaddingUnit
                          : "px")
                        : "0"
                      : "0",

                paddingRight:
                  props.canvasPadding && !state.mobileView
                    ? props.canvasPadding[1] +
                    (props.canvasPaddingUnit ? props.canvasPaddingUnit : "px")
                    : props.canvasPaddingMobile && state.mobileView
                      ? props.canvasPaddingMobile
                        ? props.canvasPaddingMobile[1] +
                        (props.canvasPaddingUnit
                          ? props.canvasPaddingUnit
                          : "px")
                        : "0"
                      : "0",

                paddingBottom:
                  props.canvasPadding && !state.mobileView
                    ? props.canvasPadding[2] +
                    (props.canvasPaddingUnit ? props.canvasPaddingUnit : "px")
                    : props.canvasPaddingMobile && state.mobileView
                      ? props.canvasPaddingMobile
                        ? props.canvasPaddingMobile[2] +
                        (props.canvasPaddingUnit
                          ? props.canvasPaddingUnit
                          : "px")
                        : "0"
                      : "0",

                paddingLeft:
                  props.canvasPadding && !state.mobileView
                    ? props.canvasPadding[3] +
                    (props.canvasPaddingUnit ? props.canvasPaddingUnit : "px")
                    : props.canvasPaddingMobile && state.mobileView
                      ? props.canvasPaddingMobile
                        ? props.canvasPaddingMobile[3] +
                        (props.canvasPaddingUnit
                          ? props.canvasPaddingUnit
                          : "px")
                        : "0"
                      : "0",

                marginTop:
                  props.canvasMargin && !state.mobileView
                    ? props.canvasMargin
                      ? props.canvasMargin[0] +
                      (props.canvasMarginUnit ? props.canvasMarginUnit : "px")
                      : "0"
                    : props.canvasMarginMobile && state.mobileView
                      ? props.canvasMarginMobile
                        ? props.canvasMarginMobile[0] +
                        (props.canvasMarginUnit ? props.canvasMarginUnit : "px")
                        : "0"
                      : "0",
                marginBottom:
                  props.canvasMargin && !state.mobileView
                    ? props.canvasMargin[1] +
                    (props.canvasMarginUnit ? props.canvasMarginUnit : "px")
                    : props.canvasMarginMobile && state.mobileView
                      ? props.canvasMarginMobile
                        ? props.canvasMarginMobile[1] +
                        (props.canvasMarginUnit ? props.canvasMarginUnit : "px")
                        : "0"
                      : "0",
                marginLeft: "auto",
                marginRight: "auto",
                backgroundImage: props.bgImage ? `url(${props.bgImage})` : "",
                backgroundRepeat: props.bgRepeat ? props.bgRepeat : "bg-repeat",
                backgroundSize: props.bgSize ? props.bgSize : "auto",
                fontFamily: `${props.selectedFont}`,
                float: "none",
              }}
            >
              {/* -------------   Mobile View Hamburger Menu    -------------*/}
              {/* Editor Canvas STARTS Here */}
              {!state.animateModal && (
                <Navbar
                  mobileView={state.mobileView}
                  newLayoutTitle={state.newLayoutTitle}
                  onChangeTitle={(event) =>
                    setState({ ...state, newLayoutTitle: event.target.value })
                  }
                  createNewBtn={() => {
                    setTitleValueInRedux();
                  }}
                  enableWidthForRow={props.enableWidthForRow}
                  width={props.containerWidth}
                  saveAsBlock={state.animateModal}
                />
              )}

              {state.animateModal ? (
                <SaveAsBlock
                  userID={userID}
                  sessionID={sessionID}
                  initP={initP}
                  storeDATA={props.storeDATA}
                  animateModalState={animateModalState}
                  choosenBlockElement={state.choosenBlockElement}
                  containerWidth={props.containerWidth}
                  layout={props.layout}
                  selectedFont={props.selectedFont}
                  preset={props.preset}
                  showAddElement={state.showAddElement}
                  tool={tool}
                  preventDrop={state.payload && state.payload.data == "Row"}
                  elementsFont={props.elementsFont}
                  pagesList={translateStringLinkToObjectLink()}
                  changeColmLayout={changeColmLayout}
                  payload={state.payload}
                  mobileView={state.mobileView}
                  googleFonts={state.googleFonts}
                  onAddElementorColumn={onAddElementorColumn}
                  onAddElementorColumnInColumn={onAddElementorColumnInColumn}
                  gridGuideColumns={state.gridGuideColumns}
                  gridGuideGutterSpace={state.gridGuideGutterSpace}
                  addedIndex={state.addedIndex}
                  itemID={state.itemID}
                  clickedImage={state.clickedImage}
                  clickedImageID={state.clickedImageID}
                  x
                  deleteElement={deleteElement}
                  cloneElement={cloneElement}
                  addRemoveColumn={addRemoveColumn}
                  imageClicked={state.imageClicked}
                  tinyMCEFonts={state.tinyMCEFonts}
                  modalUpload={state.modalUpload}
                  selectedFile={state.selectedFile}
                  videoDataID={state.videoDataID}
                  videoClicked={state.videoClicked}
                  editID={state.editID}
                  resizeColumn={(id) => {
                    setState({
                      ...state,
                      resizeID: state.resizeID !== id ? id : null,
                    });
                  }}
                  resizeID={state.resizeID}
                  toggleUploadPopup={toggleUploadPopup}
                  getSizes={getSizes}
                  columnGap={props.columnGap ? props.columnGap : "0"}
                  rowGap={props.rowGap ? props.rowGap : "0"}
                >
                  {state.animateModal && (
                    <Navbar
                      mobileView={state.mobileView}
                      newLayoutTitle={state.newLayoutTitle}
                      onChangeTitle={(event) =>
                        setState({
                          ...state,
                          newLayoutTitle: event.target.value,
                        })
                      }
                      createNewBtn={() => {
                        setTitleValueInRedux();
                      }}
                      enableWidthForRow={props.enableWidthForRow}
                      width={props.containerWidth}
                      saveAsBlock={state.animateModal}
                    />
                  )}
                </SaveAsBlock>
              ) : (
                <div
                  onDragEnter={(e) => {
                    onDragEnter(
                      e,
                      null,
                      null,
                      {
                        data: "canvas-drop-container",
                        id: "canvas-drop-container",
                      },
                      null,
                      false
                    );
                  }}
                  onDragOver={(e) => {
                    e.preventDefault();
                  }}
                  onDrop={(e) => {
                    onDrop(e);
                  }}
                  className={
                    "canvas-drop-container " +
                    (props.layout && props.layout.length === 0
                      ? " noContent empty-canvas-drop-container"
                      : " ")
                  }
                >
                  <ElementsRender
                    parent={Object({
                      data: "canvas-drop-container",
                      id: "canvas-drop-container",
                    })}
                    enableWidthForRow={
                      state.mobileView ? false : props.enableWidthForRow
                    }
                    animateModalState={state.animateModal}
                    selectedFont={props.selectedFont}
                    preset={props.preset}
                    showAddElement={state.showAddElement}
                    tool={tool}
                    preventDrop={state.payload && state.payload.data == "Row"}
                    elementsFont={props.elementsFont}
                    containerWidth={props.containerWidth}
                    pagesList={translateStringLinkToObjectLink()}
                    changeColmLayout={changeColmLayout}
                    payload={state.payload}
                    mobileView={state.mobileView}
                    userID={userID}
                    initP={initP}
                    sessionID={sessionID}
                    googleFonts={state.googleFonts}
                    onAddElementorColumn={onAddElementorColumn}
                    onAddElementorColumnInColumn={onAddElementorColumnInColumn}
                    gridGuideColumns={state.gridGuideColumns}
                    gridGuideGutterSpace={state.gridGuideGutterSpace}
                    dragOverParent={state.dragOverParent}
                    dragOverColumn={state.dragOverColumn}
                    dragOverChildren={state.dragOverChildren}
                    addedIndex={state.addedIndex}
                    itemID={state.itemID}
                    clickedImage={state.clickedImage}
                    clickedImageID={state.clickedImageID}
                    deleteElement={deleteElement}
                    cloneElement={cloneElement}
                    addRemoveColumn={addRemoveColumn}
                    imageClicked={state.imageClicked}
                    tinyMCEFonts={state.tinyMCEFonts}
                    modalUpload={state.modalUpload}
                    selectedFile={state.selectedFile}
                    videoDataID={state.videoDataID}
                    videoClicked={state.videoClicked}
                    editID={state.editID}
                    resizeColumn={(id) => {
                      setState({
                        ...state,
                        resizeID: state.resizeID !== id ? id : null,
                      });
                    }}
                    resizeID={state.resizeID}
                    toggleUploadPopup={toggleUploadPopup}
                    getSizes={getSizes}
                    columnGap={props.columnGap ? props.columnGap : "0"}
                    rowGap={props.rowGap ? props.rowGap : "0"}
                  />
                </div>
              )}

              {props.tool === "Blocks" && (
                <BlocksThumbDND
                  userID={userID}
                  sessionID={sessionID}
                  flimpID={flimpID}
                  closeBlocksSidebar={() => {
                    props.setTool(null);
                  }}
                  moduleDragStarted={(value) => {
                    setState({
                      ...state,
                      moduleDragStarted: value,
                    });
                  }}
                  mobileView={state.mobileView}
                  Layout={props.layout}
                  getKeyArray={getKeyArray()}
                  TemplateWrap={props.flimpTemplateID}
                  ID={id}
                  closeTool={() => {
                    props.setTool(null);
                  }}
                />
              )}

              {props.tool === "Templates" && (
                <Templates
                  userID={userID}
                  sessionID={sessionID}
                  closeTemplatesPopup={() => {
                    props.setTool(null);
                  }}
                  ID={id}
                  getKeyArray={getKeyArray()}
                  mobileView={state.mobileView}
                  moduleDragStarted={(value) => {
                    setState({
                      ...state,
                      moduleDragStarted: value,
                    });
                  }}
                  TemplateWrap={props.flimpTemplateID}
                />
              )}

              {props.tool === "Icons" && (
                <Icons
                  close={() => {
                    props.setTool(null);
                  }}
                />
              )}

              {state.closingEditor ? (
                <div className="closingEditor">
                  <div className="loading"></div>
                  <p>Please wait</p>
                </div>
              ) : null}
              <ToastContainer position="top-center" autoClose={5000} />

              <div className="clearfix" />
              {state.addBlockFlag ? (
                <Blocks
                  ID={state.addBlockElementId}
                  userID={userID}
                  sessionID={sessionID}
                  CloseLayout={() => {
                    setState({
                      ...state,
                      addBlockFlag: false,
                      layoutTool: false,
                      addBlockElementId: "",
                    });
                  }}
                  closeBlocks={() => {
                    setState({
                      ...state,
                      addBlockFlag: false,
                      layoutTool: false,
                      addBlockElementId: "",
                    });
                  }}
                />
              ) : null}
            </div>
          </div>
        </GridGuidelines>
      </div>
      {props.showHistory && <SideBar />}
      {props.globalStyleComponents && <GlobalStyleComponents />}
    </div>
  );
};

Flimp.propTypes = {};
const mapStateToProps = (state) => {
  return {
    bgImage: state.present.bgImage,
    bgVideo: state.present.bgVideo,
    bgType: state.present.bgType,
    bgContainerRepeat: state.present.bgContainerRepeat,
    bgContainerSize: state.present.bgContainerSize,
    bgImageContainer: state.present.bgImageContainer,
    bgImageContainerId: state.present.bgImageContainerId,
    bgImageId: state.present.bgImageId,
    bgRepeat: state.present.bgRepeat,
    bgSize: state.present.bgSize,
    canvasStyle: state.present.canvasStyle,
    canvasMargin: state.present.canvasStyle.canvasMargin,
    canvasMarginMobile: state.present.canvasStyle.canvasMarginMobile,
    canvasMarginUnit: state.present.canvasStyle.canvasMarginUnit,
    canvasPadding: state.present.canvasStyle.canvasPadding,
    canvasPaddingMobile: state.present.canvasStyle.canvasPaddingMobile,
    canvasPaddingUnit: state.present.canvasStyle.canvasPaddingUnit,
    columnGap: state.present.canvasStyle.columnGap,
    containerBg: state.present.containerBgColor,
    containerWidth: state.present.containerWidth,
    editTextIndex: state.present.editTextIndex,
    elementsFont: state.present.canvasStyle.elementsFont,
    enableWidthForRow: state.present.enableWidthForRow,
    flimpTemplateID: state.present.flimpTemplateID,
    fontSizes: state.present.fontSizes,
    glblClrs: state.present.colorsGlobal,
    layout: state.present.layout,
    layoutList: state.present.layoutList,
    layoutTitle: state.present.layoutTitle,
    layoutLanguages: state.present.layoutLanguages,
    meta_title: state.present.meta_title,
    navigationSearch: state.present.navigationSearch,
    navigationAlign: state.present.navigationAlign,
    navigationStyle: state.present.navigationStyle
      ? state.present.navigationStyle
      : null,
    overrideCanvasFont: state.present.canvasStyle.overrideCanvasFont,
    percentage: state.present.percentage,
    pixel: state.present.pixel,
    preset: state.present.preset,
    rowGap: state.present.canvasStyle.rowGap,
    selectedFont: state.present.selectedFont,
    storeDATA: state.present,
    surroundBg: state.present.surroundBg,
    text: state.present.text,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addDescription: (descriptionVal) =>
      dispatch(actionTypes.description(descriptionVal)),
    addTitle: (titleVal) => dispatch(actionTypes.title(titleVal)),
    canvasPush: (canvasVal) => dispatch(actionTypes.canvas(canvasVal)),
    clearHistory: () => dispatch(UndoActionCreators.clearHistory()),
    infoPushTitle: (infoTitle) => dispatch(actionTypes.infoTitle(infoTitle)),
    infoPushDesc: (infoDesc) => dispatch(actionTypes.infoDesc(infoDesc)),
    infoPushMetaTitle: (infoMeta_title) =>
      dispatch(actionTypes.infoMeta_title(infoMeta_title)),
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
    setLayoutLanguages: (newArray) =>
      dispatch(actionTypes.set_layout_languages(newArray)),
    setDefaultPage: (title) => dispatch(actionTypes.set_default_page(title)),
    navClassName: (className) => dispatch(actionTypes.nav_class(className)),
    push_navigation_align: (value) =>
      dispatch(actionTypes.navigation_align(value)),
    push_navigation_search: (value) =>
      dispatch(actionTypes.navigation_search(value)),
    push_navigation_style: (value) =>
      dispatch(actionTypes.navigation_style(value)),
    pushBgContainerRepeat: (bgRepeat) =>
      dispatch(actionTypes.bg_repeat_container(bgRepeat)),
    pushBGContainerimage: (image, id) =>
      dispatch(
        actionTypes.bg_image_container({
          bgImageContainer: image,
          bgImageContainerId: id,
        })
      ),
    pushBgContainerSize: (bgSize) =>
      dispatch(actionTypes.bg_size_container(bgSize)),
    pushBGimage: (image, id) =>
      dispatch(actionTypes.bg_image({ bgImage: image, bgImageId: id })),
    pushBgRepeat: (bgRepeat) => dispatch(actionTypes.bg_repeat(bgRepeat)),
    pushBgSize: (bgSize) => dispatch(actionTypes.bg_size(bgSize)),
    pushContainerWidth: (width) => dispatch(actionTypes.container_width(width)),
    pushElementFonts: (value) =>
      dispatch(actionTypes.override_element_fonts(value)),
    pushFlimpTemplateID: (index) => dispatch(actionTypes.flimp_tmp_id(index)),
    pushGlobalColorPreset: (presetColor) =>
      dispatch(actionTypes.preset(presetColor)),
    pushPercentage: (percentageVal) =>
      dispatch(actionTypes.percentage(percentageVal)),
    pushPixel: (pixelVal) => dispatch(actionTypes.pixel(pixelVal)),
    pushTextIndex: (index) => dispatch(actionTypes.text_index(index)),
    reorderLayoutList: (list) =>
      dispatch(actionTypes.reorder_layout_list(list)),
    resetCanvas: () => dispatch(actionTypes.reset()),
    setLayoutTitle: (value) => dispatch(actionTypes.set_layout_title(value)),
    layoutListArray: (layoutList) =>
      dispatch(actionTypes.set_layout_list(layoutList)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Flimp);
